import { useQuery } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";

const PAGE_SIZE = 1000;
const MAX_PAGES = 50;

const fetchAllGroupMemberIds = async (groupId: number): Promise<string[]> => {
	const ids: string[] = [];
	let page = 1;

	for (let i = 0; i < MAX_PAGES; i++) {
		const response = await cmsClient.get<CMSPaginatedData<IGroupMember>>(
			`/users/groups/${groupId}/members/`,
			{
				params: { page, page_size: PAGE_SIZE }
			}
		);
		const results = response.data.results ?? [];
		for (const member of results) {
			ids.push(member.user_id);
		}
		if (!response.data.next || results.length < PAGE_SIZE) {
			break;
		}
		page += 1;
	}

	return ids;
};

const useAllGroupMemberIds = (
	groupId: number,
	options: { enabled?: boolean } = {}
) => {
	return useQuery(
		["group-member-ids", groupId],
		() => fetchAllGroupMemberIds(groupId),
		{
			enabled:
				(options.enabled ?? true) && Number.isFinite(groupId) && groupId > 0
		}
	);
};

export default useAllGroupMemberIds;
